import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0150',
    ecrans: ['00-2'],
    params: ['id',
             'mpecleint',
             'mpdcleint']
});
